/* eslint-disable react-hooks/rules-of-hooks */
import React, { useEffect } from 'react'
import { datadogRum } from '@datadog/browser-rum'
import loadable from '@loadable/component'
import { Theme } from '@truepill/react-capsule'
import { useHistory } from 'react-router-dom'

import { useAuth0 } from '@auth0/auth0-react'
import { useGlobalState } from './Global/GlobalContext'
import Layout from './Global/Layout'
import Routes from './Global/Router'

import '@truepill/react-capsule/dist/default-theme.css'

import { getCookieToken, isEMRTokenValid } from './Global/Utils'
import ErrorBoundary from './Components/ErrorBoundary'
import Drawer from './Components/Common/Drawer'
import { useDrawerState } from './Global/DrawerContext'
import { ModalLayer } from './Components/Common/ModalLayer'
import SwitchRole from './Components/MultipleRoles/SwitchRole'
import { RedirectToAfterRoleSelection } from 'src/Global/Router'

const Header = loadable(() => import('./Components/Header'))

const App = () => {
  const {
    headerState,
    appTokenCall,
    redirectToAfterRoleSelection,
    verifySession,
  } = useGlobalState()
  const { open, onClose, drawerContent, showCloseButton } = useDrawerState()
  const { isLoading: isAuth0Loading, isAuthenticated } = useAuth0()
  const history = useHistory()

  if (window.location.pathname === '/healthcheck') {
    return <div>I'm alive!</div>
  }

  // eslint-disable-next-line react-hooks/rules-of-hooks
  useEffect(() => {
    if (!isAuth0Loading) {
      if (isAuthenticated) {
        const authToken = getCookieToken()
        if (!isEMRTokenValid(authToken)) {
          appTokenCall()
        } else {
          verifySession(authToken)
        }
      } else if (!isAuthenticated) {
        history.push('/')
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAuthenticated])

  useEffect(() => {
    switch (redirectToAfterRoleSelection) {
      case RedirectToAfterRoleSelection.MAIN:
        history.push('/')
        break
      case RedirectToAfterRoleSelection.ROLES:
        history.push('/roles')
        break
      default:
        break
    }
  }, [redirectToAfterRoleSelection, history])

  datadogRum.startView()
  return (
    <Theme>
      <Header {...headerState} />
      {isAuth0Loading ? (
        <></>
      ) : (
        <>
          <Layout>
            <ErrorBoundary>
              <Routes />
              <Drawer
                open={open}
                onClose={onClose}
                showCloseButton={showCloseButton}
              >
                {drawerContent}
              </Drawer>
              {redirectToAfterRoleSelection ===
                RedirectToAfterRoleSelection.SWITCH_ROLE_MODAL && (
                <ModalLayer>
                  <SwitchRole />
                </ModalLayer>
              )}
            </ErrorBoundary>
          </Layout>
        </>
      )}
    </Theme>
  )
}

export default App
